<template>
  <article>
    <!-- height: 65px -->
    <div ref="header">
      <search-input v-model="queryForm.keyword" placeholder-word="请输入车牌号码" @on-search="search"></search-input>
    </div>

    <scroller
      v-model="status"
      lock-x scrollbar-y
      use-pullup
      use-pulldown
      :height="scrollerHeight"
      @on-pullup-loading="loadMore"
      @on-pulldown-loading="search"
      :pullup-config="{content:'',upContent:'',downContent:'',loadingContent:'加载中...'
      }"
      :pulldown-config="{content:'',upContent:'',downContent:'',loadingContent:'更新中...'
      }"
      v-if="totalCount">
      <div class="mt-20">
        <group v-for="(item,index) in dataList" :key="index">
          <cell @click.native="onShowDetail(item)" class="all_list all-reserv-list">
            <!--<span class="non-store-tip" v-if="!item.is_owner">非本店</span>-->
            <div class="identifications">
              <span class="identification non-store-tip" v-if="!item.is_owner">非本店</span>
              <span class="identification this-product" v-if="item.is_self_brand">本品</span>
            </div>
            <p slot="after-title" class="title">{{item.plate_number}} {{item.insurance_rating ? `（保险${item.insurance_rating}类）`:''}}<img :src="item.brand_image_url" alt="" v-if="item.brand_image_url">
            </p>
            <div slot="after-title" class="p2 show-time">
              <span class="store-time time">进店：{{item.visited_at | hideSecond}} {{!item.is_entered_workshop ? '（未进车间）' : ''}}</span>
              <span class="workshop-time time" v-if="item.workshop_visited_at">进车间：{{ item.workshop_visited_at | hideSecond }}</span>
            </div>
          </cell>
          <cell>
            <div slot="value" class="operate_btn">
              <x-button mini plain type="primary" @click="release('trajectory', item.visit_id)">车辆轨迹</x-button>
              <x-button mini plain type="primary" @click="release('create', item.visit_id)" v-if="hasOutBtn(item)">发起放行</x-button>
              <x-button mini plain type="primary" @click="release('detail', item.visit_id)" v-if="item.has_exiting_process && (item.is_in_processing || item.is_latest_rejected)">审核进度</x-button>
            </div>
          </cell>
        </group>
        <p class="tip-text1">共{{totalCount}}条记录</p>
      </div>
    </scroller>
    <no-car v-else></no-car>
  </article>
</template>
<script>
import {
  XButton,
  Scroller,
  Cell,
  Group
} from '@lx-frontend/cvux'
import SearchInput from '../components/SearchInput'
import NoCar from '../components/NoCar'
import cache from '../../common/cache'
export default {
  components: {
    SearchInput,
    NoCar,
    XButton,
    Scroller,
    Cell,
    Group
  },
  data() {
    return {
      status: {
        pulldownStatus: 'default'
      },
      queryForm: {
        page: 1,
        count: 10,
        keyword: ''
      },
      totalCount: 0,
      totalPage: 0,
      dataList: [],
      scrollerHeight: ''
    }
  },
  created () {
    this.getData()
  },
  mounted() {
    this.scrollerHeight = `-${this.$refs.header.offsetHeight}px`
    cache.clearSessionData('sel_rule')
    cache.clearSessionData('brand_id')
    cache.clearSessionData('sel_change')
    cache.clearSessionData('barriergate_data')
  },
  filters: {
    // 隐藏日期中的秒
    hideSecond(dateStr) {
      return dateStr ? dateStr.replace(/:\d{2}$/, '') : '--'
    }
  },
  methods: {
    hasOutBtn(item) {
      if (item.plate_number.includes('无P')) return false
      const { can_start_exiting_process, is_in_processing, is_latest_rejected, is_owner, is_customer_requisition } = item
      return can_start_exiting_process && !is_in_processing && !is_latest_rejected && is_owner && !is_customer_requisition
    },
    search() {
      this.$store.dispatch('UPDATE_ALL_LIST_KEYWORD', this.queryForm.keyword)
      this.queryForm.page = 1
      this.totalCount = 0
      this.totalPage = 0
      this.getData()
    },
    getData() {
      this.queryForm.keyword = this.$store.state.barriergate.keyword
      this.switchLoading({ status: true, text: '加载中...' })
      this.$rest.barriergate.getAllFlowList(this.queryForm).then(res => {
        if (res.code === 0) {
          let data = res.data
          let count = this.queryForm.count
          this.dataList = data.visits
          this.totalCount = data.total_count
          this.totalPage = parseInt((this.totalCount + count - 1) / count)
          this.status.pulldownStatus = 'default'
        } else {
          this.showToast(res.message)
        }
        this.switchLoading({ status: false })
      })
    },
    loadMore(done) {
      if (this.queryForm.page < this.totalPage) {
        this.queryForm.page++
        this.$rest.barriergate.getAllFlowList(this.queryForm).then(res => {
          if (res.code === 0) {
            let data = res.data
            let count = this.queryForm.count
            this.totalCount = data.total_count
            this.totalPage = parseInt((this.totalCount + count - 1) / count)
            this.dataList.push(...data.visits)
            done(100)
          } else {
            this.showToast(res.message)
          }
        })
      } else {
        done()
      }
    },
    release(action, id) {
      if (action === 'create') {
        this.$router.push(`/barriergate/create/${id}`)
      } else if (action === 'trajectory') {
        this.$router.push(`/barriergate/trajectory/detail/${id}/0`)
      } else { // 详情
        this.$router.push(`/barriergate/flow/detail/${id}/0`)
      }
    },
    onShowDetail(item) {
      // let info = [
      //   {car_id: item.car_id},
      //   {plate_number: item.plate_number}
      // ]
      // this.$router.push({
      //   path: '/cus_info',
      //   query: item.insurance_rating ? info[0] : info[1]
      // })
    }
  }
}
</script>
<style scoped lang="less">
  @import "../../stylesheets/modules/barriergate/list.less";
</style>
